<template>
  <BRow>
    <BCol cols="4">
      <p class="font-weight-bolder">عنوان</p>
    </BCol>
    <BCol cols="4">
      <p class="font-weight-bolder">پیش نمایش تصویر</p>
    </BCol>
    <BCol cols="4">
      <p class="font-weight-bolder">جزئیات</p>
    </BCol>
    <BCol cols="12" class="mt-0">
      <hr class="mt-0" />
    </BCol>

    <ResourceDetailsSectionContent
      v-for="(resourceDetails, index) in resourceDetails"
      :key="index"
      :resourceDetails="resourceDetails"
      :resourceId="resourceId"
      @refetch="refetch"
    ></ResourceDetailsSectionContent>
    <hr />
  </BRow>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    resourceDetails: {
      type: Array,
    },
    resourceId: {
      type: [Number, String],
    },
  },
  data() {
    return {};
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
  },
  components: {
    ResourceDetailsSectionContent,
    BRow,
    BCol,
    BButton,
    BImg,
  },
};
import ResourceDetailsSectionContent from "@/views/components/Resources/ResourceDetailsSectionContent.vue";
import { BRow, BCol, BButton, BImg } from "bootstrap-vue";
</script>
